<template>
  <div class="portfoliofilters">
    <h2 class="config-title">{{ $t("available-filters") }} {{ fields.length }}</h2>
    <div v-loading="loading" class="row row-gap--5">
      <div class="col-3">
        <span>{{ $t("property") }}</span>
        <el-select v-model="propertyopt" class="mt-05" :placeholder="$t('select-property')">
          <el-option v-for="item in fields" :key="item.prop" :label="item.label" :value="item.prop">
            {{ item.label }}
          </el-option>
        </el-select>
      </div>
      <div class="col-2">
        <span>{{ $t("operator") }}</span>
        <el-select v-model="operatoropt" class="mt-05" :placeholder="$t('select-operator')">
          <el-option v-for="item in operators" :key="item.id" :label="$t(item.literal)" :value="item.id">
            {{ $t(item.literal) }}
          </el-option>
        </el-select>
      </div>
      <div class="col-3">
        <span>{{ $t("value") }}</span>
        <div class="input-value-filter">
          <textInput v-model="valueopt" :placeholder="$t('enter-value')" />
        </div>
      </div>
      <div class="col-1">
        <span>{{ $t("condition") }}</span>
        <el-select v-model="conditionopt" class="mt-05" placeholder=" ">
          <el-option v-for="(item, index) in conditions" :key="item.id + index" :label="$t(item.literal)" :value="item.id">
            {{ $t(item.literal) }}
          </el-option>
        </el-select>
      </div>
      <div class="col-2 btn-add-filter-container ml-2">
        <div>
          <button class="brains-type5-btn" @click="addfilter()">{{ $t("add-filter") }}</button>
        </div>
      </div>
    </div>
    <div v-if="filters.length > 0" class="row row-gap--5 mt-3">
      <div class="col-12 container-table-list-filters">
        <table class="brains-table" aria-describedby="portfoliofilter">
          <thead>
            <tr>
              <th>{{ $t("group-option") }}</th>
              <th>{{ $t("area-option") }}</th>
              <th>{{ $t("value") }} 1</th>
              <th>{{ $t("condition") }}</th>
              <th>{{ $t("userData.actions") }}</th>
              <th>{{ $t("enabled-title") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(filter, index) in filters" :key="index">
              <td>{{ filter.label }}</td>
              <td>{{ filter.operatoropt }}</td>
              <td>{{ filter.value }}</td>
              <td>{{ filter.conditionopt }}</td>
              <td>
                <button class="brains-type5-btn" @click="deletefilter(filter)">{{ $t('portfoliosSelector.delete') }}</button>
              </td>
              <td>
                <button v-if="filter.enabled" class="brains-type5-btn" @click="disablefilter(filter.enabled, index)">{{ $t('enabled') }}</button>
                <button v-else class="brains-type5-btn" @click="disablefilter(filter.enabled, index)">{{ $t('disabled') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container-footer-modal-save-filters">
      <button class="brains-type1-btn" :class="{'disabled-pf-filters-btn' : filters.length === 0}" @click="applyfilter(true)">{{ $t("apply-filter") }}</button>
    </div>
  </div>
</template>

<script>
import textInput from '@/components/designComponents/textInput'
import { mapState } from 'vuex'
export default {
  name: 'PortfolioFilterControl',
  components: {
    textInput
  },
  data() {
    return {
      loading: false,
      // fields: [],
      propertyopt: null,
      operatoropt: 'equals',
      conditionopt: null,
      enable: true,
      operators: [
        {
          id: 'equals',
          literal: 'op-equals'
        },
        {
          id: 'contains',
          literal: 'op-contains'
        },
        {
          id: 'minus',
          literal: 'op-minus'
        },
        {
          id: 'mayor',
          literal: 'op-mayor'
        }
      ],
      valueopt: null,
      filters: [],
      conditions: [
        {
          id: 'AND',
          literal: 'condition-and'
        },
        {
          id: 'OR',
          literal: 'condition-or'
        }
      ]
    }
  },
  computed: {
    ...mapState('portfolio', {
      portfolioid: (state) => state.currentportfolio.id,
      currentPortfolio: (state) => state.currentportfolio,
      current_filters: (state) => state.current_filters

    }),
    fields: function() {
      /*
      if (this.currentPortfolio.tableColumns !== undefined && this.currentPortfolio.tableColumns.length > 0) {
        return this.currentPortfolio.tableColumns.map((item) => {
          return {
            prop: item.brainsId,
            label: item.clientTitle
          }
        })
      } else
      */
      const vm = this
      if (this.currentPortfolio.data !== undefined && this.currentPortfolio.data.length > 0) {
        const dat = Object.keys(this.currentPortfolio.data[0]).map((item) => {
          const matched = vm.currentPortfolio.matchColumns.filter(x => { return x.brainsId === item })
          return {
            prop: item,
            label: matched.length > 0 ? matched[0].clientTitle : item
          }
        })
        // return dat.slice(0, 5)
        return dat
      } else {
        return []
      }
    }
  },
  watch: {
    current_filters: function() {
      this.filters = this.current_filters
    }
  },
  methods: {
    applyfilter(mustclose) {
      const vm = this
      vm.loading = true
      vm.$store
        .dispatch('portfolio/loadportfoliofilter', { portfolioid: vm.portfolioid, filters: vm.filters })
        .then(() => {
          vm.loading = false
          if (mustclose) {
            vm.$parent.$parent.showfilterdialog = false
          }
          // console.log('emit filterstrats')
          vm.$root.$emit('filterstrats', { portfolioid: vm.portfolioid, filters: vm.filters })
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('error-loading-portfolio-data'),
            type: 'error'
          })
          vm.loading = false
        })
    },
    addfilter() {
      const vm = this
      if (vm.propertyopt === null || vm.operatoropt === null || vm.conditionopt === null || vm.valueopt === null) {
        vm.$message({
          showClose: true,
          message: this.$t('select-all-options'),
          type: 'error'
        })
        return
      }
      vm.filters.push({
        property: vm.propertyopt,
        operatoropt: vm.operatoropt,
        value: vm.valueopt,
        conditionopt: vm.conditionopt,
        label: vm.fields.filter((item) => { return item.prop === vm.propertyopt })[0].label,
        enabled: true
      })

      // Se inicializan las variables de los filtros
      vm.propertyopt = null
      vm.operatoropt = 'equals'
      vm.valueopt = null
      vm.conditionopt = null
      vm.enable = true
    },
    deletefilter(item) {
      const vm = this
      vm.filters = vm.filters.filter((ob) => {
        return ob !== item
      })
      // Se vuelven a aplicar los filtros disponibles actualmente para no tenerle que darle otra vez a applyfilters en caso de que no haya mas filtros
      this.applyfilter(false)
    },
    disablefilter(condition, index) {
      const vm = this
      if (condition) {
        vm.filters[index].enabled = false
      } else {
        vm.filters[index].enabled = true
      }
      // Se vuelven a aplicar los filtros disponibles actualmente para no tenerle que darle otra vez a applyfilters en caso de que no haya mas filtros
      this.applyfilter(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.brains-type2-btn:disabled {
  color: white;
  background-color: grey;
}

.portfoliofilters {
  padding: 20px;

  .config-title {
    font-size: 20px;
    font-family: "Montserrat-SemiBold",sans-serif;
    margin-bottom: 25px;
  }
}

.btn-add-filter-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  div {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 3px;
  }
}

.disabled-pf-filters-btn {
  pointer-events: none;
  color: #c2c2c2;
  outline: none;
  border: 1px solid lightgrey;
  background-color: #f0f0f0;
}

.container-footer-modal-save-filters {
  text-align: right;
  margin-top: 20px;
}

.container-table-list-filters {
  max-height: 350px;
  overflow: scroll;
}

.input-value-filter {
  .inp_container {
    margin-top: 7px;
  }
}
</style>
